import { render } from "./ChangeOwnPassowrdModal.vue?vue&type=template&id=c8a37c0c&scoped=true"
import script from "./ChangeOwnPassowrdModal.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./ChangeOwnPassowrdModal.vue?vue&type=script&charset=utf-8&lang=js"

import "./ChangeOwnPassowrdModal.vue?vue&type=style&index=0&id=c8a37c0c&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8a37c0c"]])

export default __exports__